import AbstractItemResource from '../abstract/abstract-item-resource';
import {Resource, ContentType} from 'sdk/src/defines';
import Content from './content';
import {DropDownItem} from '../../utility/types';
import {TFunction} from 'react-i18next';

export type StatisticItem = {
    contentId?: string,
    episodeId?: string,
    seconds: number,
    seasonId?: string,
    shows?: number,
    views: number,
    users?: number,
    uniqueUsers?: number,
    demoUsers?: number,
    type?: ContentType,
    title?: string,
    seasonTitle?: string,
    episodeTitle?: string,
    date?: string,
}

export type PlatformItem = {
    seconds?: string,
    shows?: number,
    users?: number,
    uniqueUsers?: number,
    demoUsers?: number,
}

export type OfferItem = {
    price: number,
    intervalType: string,
    intervalLength: string,
    count: number,
}

export type PlanItem = {
    title: string,
    count: number,
}

class Statistic extends AbstractItemResource {
    public resourceType: Resource = Resource.STATISTICS;

    public declare data: StatisticItem[];

    public declare platforms: {[platform: string]: PlatformItem};

    public declare offers: {[offerId: string]: OfferItem};

    public declare plans: {[planId: string]: PlanItem};

    public static contentTypes(): ContentType[] {
        return [ContentType.CHANNEL, ContentType.VIDEO, ContentType.SERIES, ContentType.SHOW];
    }

    public static contentTypesForDropDown(t: TFunction): DropDownItem[] {
        const allowedTypes: ContentType[] = Statistic.contentTypes();
        const result: DropDownItem[] = [{label: t('statistics.allTypes'), value: null}];

        return [
            ...result,
            ...Content.typesForDropDown(t)
                .filter((el: DropDownItem) => allowedTypes.includes(el.value as ContentType)),
        ];
    }

    public static subscriberStatusesForDropDown(t: TFunction): DropDownItem[] {
        return [
            {label: t('statistics.allSubscribers'), value: 'all'},
            {label: t('users.active'), value: 'active'},
            {label: t('users.disabled'), value: 'disabled'},
            {label: t('users.emailNotVerified'), value: 'emailNotVerified'},
            {label: t('users.phoneNotVerified'), value: 'phoneNotVerified'},
        ];
    }

    public static registrationStatusesForDropDown(t: TFunction, empty?: string): DropDownItem[] {
        const result: DropDownItem[] = [];

        if (empty) {
            result.push({
                label: empty,
                value: undefined,
            });
        }

        result.push(
            {
                label: t('statistics.registrationConfirmed'),
                value: 'confirmed',
            },
            {
                label: t('statistics.registrationNotConfirmed'),
                value: 'notConfirmed',
            },
            {
                label: t('statistics.registrationAbandoned'),
                value: 'abandoned',
            },
        );

        return result;
    }
}

export default Statistic;
